"use client";

import Button from "@/components/ui/Button";
import styles from "./LpProblem2.module.css";

const CheckIcon = () => (
    <svg width="16" height="11" viewBox="0 0 16 11" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1 5.5L5.5 10L15 1" stroke="#00BE40" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

const FEATURES = [
    "Geração automática de contratos e parcelas",
    "Emissão de boletos e integração bancária",
    "Emissão de NFe integrada",
    "Controle de repasses ao proprietário",
    "Relatórios financeiros completos",
    "Histórico completo por imóvel, contrato e pessoa",
];

export default function LpProblem2() {
    const handleScroll = (id: string) => {
        const element = document.getElementById(id);
        if (element) {
            element.scrollIntoView({ behavior: "smooth" });
        }
    };

    return (
        <section className={styles.section} id="solucao">
            <div className={styles.container}>
                <div className={styles.leftContent}>
                    <h2 className={styles.title}>
                        O sistema de gestão que organiza a operação de ponta a ponta
                    </h2>
                    <p className={styles.description}>
                        O SIMOB não é apenas um software. Ele é a base operacional da imobiliária. Ele conecta locação, vendas, financeiro, contratos, repasses, notas fiscais e indicadores em um único fluxo estruturado.
                    </p>
                    <Button onClick={() => handleScroll('contato')}>Solicitar demonstração</Button>
                </div>

                <div className={styles.rightContent}>
                    {FEATURES.map((feat, index) => (
                        <div key={index} className={styles.featureItem}>
                            <div className={styles.iconWrapper}>
                                <CheckIcon />
                            </div>
                            <span className={styles.featureText}>{feat}</span>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
